import axios from "axios";
import { Constants } from "../Constants";

const instance = axios.create({ baseURL: Constants.BASE_URL });

export type PropertyLabel = {
  id: number;
  name: string;
};

export const fetchPropertyLabels = async () => {
  try {
    return await instance.get(`/property-labels`);
  } catch (error) {
    throw error;
  }
};

export const addPropertyLabel = async (name: string) => {
  try {
    return await instance.post(`/property-labels`, { name });
  } catch (error) {
    throw error;
  }
};

export const putPropertyLabel = async (id: number, name: string) => {
  try {
    return await instance.put(`/property-labels/${id}`, { name });
  } catch (error) {
    throw error;
  }
};

export const removePropertyLabel = async (id: number) => {
  try {
    return await instance.delete(`/property-labels/${id}`);
  } catch (error) {
    throw error;
  }
};
